import React, { useState } from 'react';
import {
  FormPublicDesignFragment,
  FormPublicPageFragment,
} from '../../../graphql/fragment/form.public.fragment';
import { StyledButton } from './GEOImpact.css';
import { Box, FormControlLabel, Grid, Typography } from '@mui/material';
import ModelOrbBlurred from './assets/primary-circle-blurred-2048x2048px.png';
import ModelOrb from './assets/primary-circle-828x828px.png';
import Image from 'next/image';
import {
  START_INNOVATION_MODEL,
  START_LEFT_CONTEXT,
  START_RIGHT_CONTEXT,
} from './utils';
import { StyledCheckBox } from '@/components/styled/checkbox.input';

interface Props {
  page: FormPublicPageFragment;
  design: FormPublicDesignFragment;
  className?: string;
  next?: () => void;
  prev?: () => void;
  showProgress?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const StartPage: React.FC<Props> = ({
  page,
  design,
  next,
  prev,
  className,
  showProgress,
}) => {
  if (!page.show) {
    return null;
  }

  const [isClicked, setIsClicked] = useState(false);

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsClicked(event.target.checked);
  };

  return (
    <>
      {className === 'start-page' && (
        <Box
          sx={{
            position: 'absolute',
            top: -330,
            left: 250,
            width: '500px',
            height: '500px',
            zIndex: -2,
            pointerEvents: 'none',
            backgroundImage: `url(${ModelOrbBlurred})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'top center',
            backgroundSize: 'cover',
            margin: 0,
            padding: 0,
            display: { xs: 'none', sm: 'block' },
          }}
        />
      )}

      {className === 'start-page' && (
        <Box
          sx={{
            position: 'absolute',
            top: -415,
            right: -315,
            zIndex: -1,
            width: '800px',
            height: '800px',
            pointerEvents: 'none',
            display: { xs: 'none', sm: 'none', md: 'none', lg: 'block' },
          }}
        >
          <Image
            src={ModelOrb}
            alt='orb'
            width={800}
            height={800}
            style={{
              objectFit: 'contain',
              width: '100%',
              height: '100%',
            }}
          />
        </Box>
      )}
      <Grid
        sx={{
          marginTop: { xs: '10px', sm: '20px' },
          display: 'flex',
          flexDirection: 'column',
          textAlign: 'center',
          justifyContent: 'start',
          alignItems: { xs: 'center', sm: 'start' },
          minHeight: { xs: 'calc(100vh - 60px)', sm: 'calc(100vh - 113px)' },
          padding: { xs: '0 8px', sm: '0 24px', md: '0 20vw' },
          margin: '0px',
          overflowY: 'auto',
          overflowX: 'hidden',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            color: '#000',
            fontSize: { xs: '24px', sm: '24px' },
            fontWeight: 300,
            justifyContent: 'start',
            alignItems: { xs: 'center', sm: 'start' },
            textAlign: { xs: 'center', sm: 'start' },
            width: { xs: '100%', sm: '797px' },
          }}
        >
          <Typography
            sx={{
              typography: { xs: 'h5', sm: 'h5' },
              color: design.colors.question,
            }}
          >
            {'Where should your'} {'organization start to become'}{' '}
            {'“GEO Ready”?'}
          </Typography>
          {/* <Typography
            sx={{
              typography: { xs: 'h5', sm: 'h5' },
              color: design.colors.question,
              //paddingBottom: '5px',
            }}
          >
            {'organization start to become'}
          </Typography>
          <Typography
            sx={{
              typography: { xs: 'h5', sm: 'h5' },
              fontWeight: 'bold',
              color: design.colors.question,
              //paddingBottom: '5px',
            }}
          >
            {'“GEO Ready”?'}
          </Typography> */}
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            fontWeight: 300,
            justifyContent: 'start',
            alignItems: 'start',
            textAlign: { xs: 'center', sm: 'start' },
            gap: { xs: '12px', sm: '25px' },
            width: '100%',
          }}
        >
          <Typography
            sx={{
              color: design.colors.question,
              whiteSpace: 'pre-wrap',
              padding: { xs: '20px 0', sm: '20px 0' },
              width: '100%',
              fontSize: { xs: '14px', sm: '14px' },
            }}
          >
            {START_LEFT_CONTEXT}
          </Typography>
          <Typography
            sx={{
              color: design.colors.question,
              whiteSpace: 'pre-wrap',
              padding: { xs: '20px 0', sm: '20px 0' },
              width: '100%',
              fontSize: { xs: '14px', sm: '14px' },
            }}
          >
            {START_RIGHT_CONTEXT}
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            border: '6px solid #FFF',
            justifyContent: { xs: 'center', sm: 'start' },
            alignItems: { xs: 'center', sm: 'start' },
            padding: { xs: '12px', sm: '12px' },

            textAlign: { xs: 'center', sm: 'start' },
          }}
        >
          <Typography
            sx={{
              typography: { xs: 'body2', sm: 'body1' },
              color: design.colors.question,
              whiteSpace: 'pre-wrap',
              fontStyle: 'italic',
              fontSize: { xs: '14px', sm: '14px' },
            }}
          >
            {START_INNOVATION_MODEL}
          </Typography>
        </Box>

        <FormControlLabel
          control={
            <StyledCheckBox
              design={design}
              id='terms'
              name='terms'
              value='0'
              checked={isClicked}
              onChange={handleCheckboxChange}
            />
          }
          // label='By participating in the Personalization Calculator, you agree to the
          // Deloitte Digital Survey Consent Agreement'
          label={
            <span>
              By participating in the Personalization Calculator, you agree to
              the Deloitte Digital{' '}
              <a
                href='https://www.deloittedigital.com/us/en/misc/consent-agreement.html'
                onClick={(e) => e.stopPropagation()}
              >
                Survey Consent
              </a>{' '}
              Agreement{' '}
            </span>
          }
          sx={{
            justifyContent: 'flex-start',
            mr: 'auto',
            width: '100%',
            textAlign: 'start',
            mt: '10px',
          }}
        />

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            fontSize: { xs: '16px', sm: '20px' },
            fontWeight: 300,
            justifyContent: { xs: 'center', sm: 'end' },
            alignItems: { xs: 'center', sm: 'end' },
            textAlign: { xs: 'center', sm: 'end' },
            width: '100%',
          }}
        >
          {className === 'start-page' && (
            <StyledButton
              background={design.colors.button}
              $buttonColor={design.colors.buttonText}
              highlight={design.colors.buttonActive}
              className={'continue-button'}
              width='157px'
              onClick={() => {
                if (showProgress !== undefined && next !== undefined) {
                  showProgress(true);
                  next();
                }
              }}
              disabled={!isClicked}
            >
              {page.buttonText || 'Get Started'}
            </StyledButton>
          )}
        </Box>
      </Grid>
    </>
  );
};
